const ACCESS_TOKEN_PREFIX = 'buyonline_access_';

export function saveBuyonlineAccessToken(resourceId: string, accessToken: string): void {
  if (!resourceId || !accessToken) {
    return;
  }
  try {
    sessionStorage.setItem(`${ACCESS_TOKEN_PREFIX}${resourceId}`, accessToken);
  } catch {
    // sessionStorage unavailable
  }
}

export function getBuyonlineAccessToken(resourceId: string): string | null {
  if (!resourceId) {
    return null;
  }
  try {
    return sessionStorage.getItem(`${ACCESS_TOKEN_PREFIX}${resourceId}`) || null;
  } catch {
    return null;
  }
}

export function withBuyonlineAccessToken<T extends Record<string, unknown>>(
  resourceId: string,
  params: T
): T & { accessToken?: string } {
  const accessToken = getBuyonlineAccessToken(resourceId);
  if (!accessToken) {
    return params;
  }
  return { ...params, accessToken };
}
